import { render, staticRenderFns } from "./PageWithoutNav.vue?vue&type=template&id=99665202&"
import script from "./PageWithoutNav.vue?vue&type=script&lang=js&"
export * from "./PageWithoutNav.vue?vue&type=script&lang=js&"
import style0 from "./PageWithoutNav.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports